/* eslint-disable import/no-anonymous-default-export */
export default {
    GET_PROFILE_STATS: '/users',
    SEARCH_USERS: '/search',
    GET_USER_NOTES: '/actions/{userId}/notes',
    POST_USER_NOTES: '/actions/{userId}/notes',
    CLOSE_SAVE_BUILDER: '/subscriptions/loans/cancel',
    CANCEL_SUBSCRIPTION: '/subscriptions/cancel',
    ADD_TRIAL_SUBSCRIPTION: '/subscriptions/create',
    RESUME_SUBSCRIPTION: '/subscriptions/resume',
    CANCEL_CREDIT_CARD: '/subscriptions/creditcards/cancel',
    CREATE_NEW_CREDIT_CARD: '/subscriptions/creditcard/new',
    ENABLE_BACKUP_PAYMENT: '/enableBackupPayment',
    DISABLE_AUTOPAY: '/disableAutoPay',
    FORCE_AUTOPAY: '/forceAutopay',
    GET_MERCHANTS: '/merchants',
    DELETE_ACCOUNT: '/{user_id}/deactivate',
    RELEASE_PHONE_NUMBER: '/{userId}/releasePhone',
    FIREBASE_ACCOUNT_INFO: '/users/{userId}/firebase',
    UPDATE_USER_INFO: '/changeInfo',
    UPDATE_USER_INFO_SILA: '/silaManualVerification',
    CHANGE_ACTIVE_PLAID: '/changeActivePlaid',
    CHANGE_DUE_DAY_CC: '/dueDateCC',
    CHANGE_DUE_DAY_SB: '/dueDateSB',
    CHARGE_BACKUP_SILA_PAYMENT: '/retrySilaPayment',
    USER_BLOCK: '/actions/blockUser',
    USER_UNBLOCK: '/actions/unblockUser',
    BLOCK_HISTORY: '/actions/blockHistory',
    ADD_SPEND_POWER: '/actions/addSpendPower',
    PLAID_BALANCES: '/plaidBalances',
    RUN_REGISTRATION: '/actions/runRegistration',
    GET_DOCUMENT_TYPES: '/documentTypes',
    GET_DOCUMENTS: '/listDocuments/user_id',
    UPLOAD_DOCUMENT: '/uploadDocument',
    FORCE_PULL_REPORT: '/forceReportPull',
    EXPERIAN_REENROLL: '/experian/reenroll',
    EXTRA_PLAID_ATTEMPT: '/extraPlaidAttempt',
    REFUND_USER: '/refundUser',
    CANCEL_REFUND: '/cancelRefund',
    TOGGLE_AUTO_RENEW_SB: '/toggleAutoRenewSB',
    WHITELIST_USER_SSN: '/whitelistUserSSN',
    UNDO_WHITELIST_USER_SSN: '/{userId}/undoWhitelistUserSSN',
    PREVIEW_INVOICE: '/subscriptions/previewInvoice',
    GET_USER_STRIPE_CHARGES: '/subscriptions/{userId}/charges',
    GET_USER_STRIPE_INVOICES: '/subscriptions/{userId}/invoices',
    GET_USER_STRIPE_DISPUTES: '/subscriptions/{userId}/{chargeId}/disputes',
    GET_USER_STRIPE_CUSTOMER: '/subscriptions/{userId}',
    GET_USER_SUBSCRIPTION_OFFERS_PREVIEW: '/subscriptions/{userId}/offers/preview',
    GET_USER_SUBSCRIPTION_OFFERS_ACCEPT: '/subscriptions/{userId}/offers/accept',
    GET_PLAID_ACCOUNT_DETAILS: '/plaid',
    GET_PLAID_EVENTS: '/plaid/{user_id}/events',
    PLAID_OWNER_NAME: '/plaid/ownerNames',
    UPDATE_SUBSCRIPTION: '/subscriptions/update',
    GET_SUBSCRIPTION_PLANS: '/subscriptions/plans',
    FIREBASE_DEVICE_EVENTS: '/firebaseDeviceEvents',
    PATCH_BLOOM_ACCOUNT: '/furnishing/bloomAccounts/{account_id}',
    POST_ACCOUNT_CLOSING: '/furnishing/closeAccount',
    POST_ACCOUNT_CLOSING_REVERSAL: '/furnishing/closeAccount/reverse',
    PATCH_BLOOM_STATEMENT: '/furnishing/statements/{bloomStatementId}',
    POST_CREATE_STATEMENT: '/furnishing/statement',
    DELETE_REVOLVING_FURNISHING_ACCOUNT: '/furnishing/accounts/creditCard/delete',
    DELETE_INSTALLMENT_FURNISHING_ACCOUNT: '/furnishing/accounts/savingsBuilder/delete',
    POST_VOID_TRANSACTIONS: '/furnishing/accounts/voidTransactions',
    USER_FURNISHING_EVENTS: '/furnishing/{userId}/events',
    GET_REFERRAL_LINK: '/subscriptions/referralLink',
    DELETE_STRIPE_CARD: '/subscriptions/stripe/{userId}/deleteCard/{cardId}',
    POST_CREATE_STRIPE_CARD: '/subscriptions/stripe/{userId}/addCard',
    POST_CREATE_PAYMENT_LINK: '/subscriptions/checkout/paymentLink',
    GET_PAYMENT_LINKS_LIST: '/subscriptions/checkout/paymentLinks',
    GET_SUBSCRIPTION_CANCELLATION_OFFER: '/subscriptions/{userId}/cancellation/offers',
    GET_USER_STATUS: '/users/{userId}/blocked',
    GET_FURNISHING_DETAILS: '/furnishing/{userId}',
    GET_USER_SUMMARY: '/users/{userId}/summary',
    GET_SUBSCRIPTION_DETAILS: '/subscriptions/{userId}/all',
    GET_FURNISHING_CHANGES: '/furnishing/{userId}/changes',
    GET_FURNISHING_ERRORS: '/furnishing/{userId}/errors',
    GET_FURNISHING_BLOOM_ACCOUNT: '/furnishing/{productId}/bloom/account',
    POST_FURNISHING_BLOOM_ACCOUNT_EVENT: '/furnishing/bloomAccounts/{accountId}/events',
    DELETE_PLAID_ACCOUNT: '/actions/plaid/{userId}/{plaidAccountId}',
    HIDE_PLAID_ACCOUNT: '/plaid/hide',
    POST_DECLARE_BANKRUPTCY: '/actions/bankruptcy',
    GET_AUTO_PAY_STATUS: '/actions/{userId}/autopay',
    POST_SET_AUTO_PAY_STATUS: '/actions/{userId}/autopay/{type}',
    GET_RENT_REPORTING: '/rentReporting',
    GET_STATEMENTS_BY_USER: '/furnishing/statements/{type}/{userId}',
    GET_STATEMENTS_BY_ACCOUNT_ID: '/creditCard/{accountId}/statements',
    GET_PRODUCT_STATEMENTS_BY_USER: '/product/statements/{type}/{statementId}',
    GET_CC_ACCOUNTS_BY_USER_ID: '/creditCards/{userId}',
    GET_CC_LEGACY_ACCOUNTS_BY_USER_ID: '/creditCards/{userId}/legacy',
    GET_CC_ACCOUNT_ACTIVITY_BY_ACCOUNT_ID: '/creditCard/{accountId}/activity',
    GET_REPORT_BY_USER_ID_REPORT_ID: '/reports/{userId}/{reportId}',
    GET_REVEAL_USER_SSN: '/users/{userId}/personal/reveal',
    POST_MATCH_USER_SSN: '/users/{userId}/personal/match',
    GET_USER_TOS: '/users/{userId}/tos',
    GET_USER_BALANCE: '/{userId}/balance',
    GET_LOAN_DETAILS: '/{userId}/loans',
    GET_LOAN_STATEMENTS: '/loan/{loanId}/statements',
    GET_REVOKE_LOGIN: '/revoke/{userId}/login',
    GET_PAYMENT_ATTEMPTS: '/{userId}/paymentAttempts',
    GET_ADVERSE_ACTIONS: '/users/{userId}/adverseActions',
    RISK_CHECK: '/riskCheck',
    GET_DOCUMENT_VERIFICATIONS: '/documentVerifications/{userId}',
    GET_DOCUMENT_VERIFICATION_LINK: '/documentVerifications/getLink',
    GET_DOCUMENT_VERIFICATION_RESULT: '/documentVerifications/{userId}/{id}/result',
    GET_DOCUMENT_VERIFICATION_IMAGES: '/documentVerifications/{userId}/{id}/images',
    SPEND_MODE: '/spendMode',
    RESET_MERCHANT_CYCLE: '/resetMerchantCycle',
    AVA_ASSIST: '/{userId}/avaAssist',
    BLOOM_CONNECTIONS: '/rentReporting/bloomConnections',
    TRADELINES: '/rentReporting/tradelines',
    SET_STRIPE_PRIMARY_CARD: '/subscriptions/stripe/primary',
    GET_HIGH_RISK_RULES: '/{userId}/highRiskRules',
    ALLOWLIST_RULE: '/rules/allowList',
    GET_ALLOWLISTED_RULES: '/{userId}/rules/allowListed',
    GET_SAVINGS_BUILDER: '/users/{userId}/savingsBuilder',
    GET_MONEY_TRANSACTIONS: '/users/{userId}/moneyTransactions',
    GET_ITERABLE_EMAILS: '/{userId}/iterableEmails',
    GET_MERCHANT_ACTIVATION_V3_EXPERIENCE: '/{userId}/creditCards/v3Experience',
    GET_MERCHANT_ACTIVATION_MERCHANT_TO_ADD_LIST: '/{userId}/creditCards/merchantsList',
    GET_MERCHANT_ACTIVATION_MERCHANTS_LIST: '/{userId}/creditCards/merchants',
    POST_MERCHANT_ACTIVATION_ADD_NEW_MERCHANT: '/{userId}/creditCards/merchant',
    DELETE_MERCHANT_ACTIVATION_MERCHANT: '/{userId}/creditCards/{merchantName}/delete',
    DELETE_MERCHANT_ACTIVATION_MERCHANT_BY_AVA: '/{userId}/creditCards/{merchantName}/deletedByAva',
    GET_SUBSCRIPTION_PAYMENT_ISSUES: '/subscriptions/{userId}/paymentIssues',
    REFUND_NEGATIVE_BALANCE: '/creditCard/refundNegativeBalance',
    GET_MONEY_MOVEMENTS: '/engineering/moneyMovements'
 }